import React from "react";
import moment from 'moment';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {
    render() {
        const manufacturingDetails = this.props.manufacturingDetails;
        const searchData = this.props.searchData;

        return (
            <div style={{ backgroundColor: "white", minHeight: "100vh", }}>
                <h3><center><u>Manufacturing Details Report</u></center></h3>
                <div>&nbsp;</div>
                <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
                <h4><center>{searchData.startDate} - {searchData.endDate}</center></h4>
                <div>&nbsp;</div>
                <div>
                    <Table aria-label="caption table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Manufacture No</TableCell>
                                <TableCell align="left">Manufacture Date</TableCell>
                                <TableCell align="right">Green Leaf Quantity (Kg)</TableCell>
                                <TableCell align="right">Withered Leaf Quantity (Kg)</TableCell>
                                <TableCell align="right">Withered Leaf Percentage (%)</TableCell>
                                <TableCell align="left">Withering Condition</TableCell>
                                <TableCell align="right">Fired Tea Quantity (Kg)</TableCell>
                                <TableCell align="right">Gross Outturn (%)</TableCell>
                                <TableCell align="right">Made Tea Quantity (Kg)</TableCell>
                                <TableCell align="right">No. of Grade</TableCell>
                                <TableCell align="right">Net Outturn (%)</TableCell>
                                <TableCell align="right">Refuse Quantity (Kg)</TableCell>
                                <TableCell align="right">Refuse Percentage (%)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {manufacturingDetails.map((data, index) => (
                                <TableRow key={index}>
                                    <TableCell align="left">{data.manufactureNumber || '-'}</TableCell>
                                    <TableCell align="left">
                                        {data.toDateOfManufaturing && moment(data.toDateOfManufaturing).isValid() && !moment(data.toDateOfManufaturing).isSame('0001-01-01')
                                            ? moment(data.toDateOfManufaturing).format('DD/MM/YYYY')
                                            : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.greenLeafAmount ? data.greenLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.witheredLeafAmount ? data.witheredLeafAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.witheredLeafPercentage ? data.witheredLeafPercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.witheringCondition ? data.witheringCondition.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.totalFireWeight ? data.totalFireWeight.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.grossOutTurn ? data.grossOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.gradeAmount ? data.gradeAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.noOfGrade ? data.noOfGrade.toLocaleString(undefined) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.netOutTurn ? data.netOutTurn.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.refuseAmount ? data.refuseAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                    <TableCell align="right">
                                        {data.refusePercentage ? data.refusePercentage.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div>&nbsp;</div>
            </div>
        );

    }

}